<template>
  <div>
    <h2 class="c-card--orders__single__order-number card-subcontainer">{{ $t('web.catalog_order_list.order_number', {order_number: order.short_order_id}) }}</h2>

    <div class="c-card--orders__single__datagroup order-info-group">
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.date') }}</dt>
        <dd class="c-card--orders__single__data__value">{{ order.created }}</dd>
      </dl>
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.points') }}</dt>
        <dd class="c-card--orders__single__data__value">
          <i class="fa fa-star t-points-icon"></i>
          {{ order.order_total }}
        </dd>
      </dl>
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.quantity') }}</dt>
        <dd class="c-card--orders__single__data__value">{{ order.item_quantity }}</dd>
      </dl>
      <dl class="c-card--orders__single__data">
        <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.order_status') }}</dt>
        <dd class="c-card--orders__single__data__value">
          <span class="c-status" :class="statusColor(order.order_status)">{{ order.order_status }}</span>
        </dd>
      </dl>
    </div>

    <div v-for="lineItem in order.line_items" :key="lineItem.id" class="card-subcontainer">
      <p class="c-card--orders__single__item">
        <router-link class="t-link" :to="{ name: 'Single Reward', params: { id: lineItem.item.id}}">
          {{ lineItem.item.name }}
        </router-link>
      </p>
      <div class="c-card--orders__single__datagroup">
        <dl class="c-card--orders__single__data">
          <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.line_item') }}</dt>
          <dd class="c-card--orders__single__data__value">{{ lineItem.line_item_number }}</dd>
        </dl>
        <dl class="c-card--orders__single__data">
          <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.points') }}</dt>
          <dd class="c-card--orders__single__data__value">
            <i class="fa fa-star t-points-icon"></i>
            {{ lineItem.line_item_points_amount_charged }}
          </dd>
        </dl>
        <dl class="c-card--orders__single__data">
          <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.updated') }}</dt>
          <dd class="c-card--orders__single__data__value">{{ lineItem.updated_at }}</dd>
        </dl>
        <dl class="c-card--orders__single__data">
          <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.order_status') }}</dt>
          <dd class="c-card--orders__single__data__value">
            <span class="c-status" :class="statusColor(lineItem.line_item_order_status)">{{ lineItem.line_item_order_status }}</span>
          </dd>
        </dl>
      </div>
      <div class="c-card--orders__single__datagroup">
        <dl class="c-card--orders__single__data" v-if="!lineItem.email_status">
          <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.shipping_status') }}</dt>
          <dd class="c-card--orders__single__data__value">
            <span class="c-status" :class="statusColor(lineItem.line_item_shipping_status)">{{ lineItem.line_item_shipping_status }}</span>
          </dd>
        </dl>
        <dl class="c-card--orders__single__data" v-if="!lineItem.email_status">
          <dt class="c-card--orders__single__data__label" v-if="lineItem.item.item_type.redemption_flow.toLowerCase() === 'digital confirmation'">{{ $t('web.catalog_order_list.travel_certificate') }}</dt>
          <dt class="c-card--orders__single__data__label" v-else>{{ $t('web.catalog_order_list.tracking') }}</dt>
          <dd class="c-card--orders__single__data__value">
            {{ lineItem.carrier_tracking }}
            <span class="c-card--orders__single__data__value__empty" v-if="!lineItem.carrier_tracking">{{ $t('web.catalog_order_list.tracking_unavailable') }}</span>
          </dd>
        </dl>
        <dl class="c-card--orders__single__data" v-if="lineItem.email_status">
          <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.email_delivery_status') }}</dt>
          <dd class="c-card--orders__single__data__value">
            {{ lineItem.email_status }}
          </dd>
        </dl>
        <dl class="c-card--orders__single__data" v-if="lineItem.email_status">
          <dt class="c-card--orders__single__data__label">{{ $t('web.catalog_order_list.email_engagement_status') }}</dt>
          <dd class="c-card--orders__single__data__value">
            {{ lineItem.email_engagement_event }}
            <span class="c-card--orders__single__data__value__empty" v-if="!lineItem.email_engagement_event">{{ $t('web.catalog_order_list.tracking_unavailable') }}</span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CatalogOrderCard',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusColor (status) {
      status = status ? status.toLowerCase() : ''
      switch (status) {
        case 'pending':
          status = 't-alert-warning'
          break
        case 'processing':
          status = 't-alert-warning'
          break
        case 'partial':
          status = 't-alert-danger'
          break
        case 'rejected':
          status = 't-alert-danger'
          break
        case 'failed':
          status = 't-alert-danger'
          break
        case 'stopped':
          status = 't-alert-danger'
          break
        case 'cancelled':
        case 'canceled':
          status = 't-alert-plain'
          break
        case 'sent':
          status = 't-alert-info'
          break
        case 'delivered':
          status = 't-alert-success'
          break
        case 'returned':
          status = 't-alert-success'
          break
        default:
          status = 't-alert-plain'
          break
      }
      return status
    }
  }
}
</script>

<style scoped>
.card-subcontainer {
  margin-bottom: 15px;
}

.order-info-group {
  border-bottom: 1px solid #dce0dc;
  margin-bottom: 15px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// CatalogOrderCard.vue?2429ee16